module.exports = __webpack_public_path__ + "9f0f26372a2726f1a4e526931c051097.fbx";